export const EnvConfig = {
  baseUrl: process.env.VUE_APP_BASE_URL,
  baseApiUrl: process.env.VUE_APP_BASE_API_URL,
};
